export default function decodeHTMLEntities(text) {
  const tempElement = document.createElement('p');
  tempElement.innerHTML = text;
  return tempElement.textContent || tempElement.innerText || '';
}
